import * as React from "react";
import { Copyright } from "./Copyright";

export const Footer = () => {
  return <Copyright />;
};
